import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { StarRating } from "./StarRating";
import { WishlistButton } from "./WishlistButton";

export const ProductCard = ({ product, onAddToCart }) => {
  const savings = product.original_price ? Math.round((1 - product.price / product.original_price) * 100) : 0;
  const stock = typeof product.stock === "number" ? product.stock : 0;
  const outOfStock = stock <= 0;
  const lowStock = stock > 0 && stock < 10;

  return (
    <div className="product-card relative" data-testid={`product-card-${product.id}`}>
      <WishlistButton productId={product.id} />
      <Link to={`/products/${product.id}`}>
        <img src={product.image_url || "https://via.placeholder.com/200"} alt={product.name} />
      </Link>
      <div className="p-4">
        {product.brand && (
          <span className="text-xs font-medium text-[#00a99d] uppercase tracking-wide">{product.brand}</span>
        )}
        <Link to={`/products/${product.id}`}>
          <h3 className="font-semibold text-gray-800 mt-1 line-clamp-2 hover:text-[#00a99d]">{product.name}</h3>
        </Link>
        <p className="text-sm text-gray-500 mt-1">{product.sku}</p>
        {(product.review_count > 0 || product.avg_rating) && (
          <div className="mt-1">
            <StarRating rating={product.avg_rating || 5} showText count={product.review_count || 0} />
          </div>
        )}
        <div className="mt-2 flex items-center gap-2">
          <span className="price">&pound;{product.price.toFixed(2)}</span>
          {product.original_price && (
            <>
              <span className="price-original">&pound;{product.original_price.toFixed(2)}</span>
              <span className="price-savings">Save {savings}%</span>
            </>
          )}
        </div>
        <p className="text-xs text-gray-500 mt-1">ex VAT</p>
        {outOfStock ? (
          <p className="text-xs font-semibold text-red-600 mt-1" data-testid={`stock-out-${product.id}`}>Out of stock</p>
        ) : lowStock ? (
          <p className="text-xs font-semibold text-orange-600 mt-1" data-testid={`stock-low-${product.id}`}>Only {stock} left</p>
        ) : null}
        <button
          onClick={() => !outOfStock && onAddToCart(product.id)}
          disabled={outOfStock}
          className={`btn-primary w-full mt-4 ${outOfStock ? "opacity-50 cursor-not-allowed" : ""}`}
          data-testid={`add-to-cart-${product.id}`}
        >
          <ShoppingCart className="w-4 h-4" />
          {outOfStock ? "Out of Stock" : "Add to Cart"}
        </button>
      </div>
    </div>
  );
};
